import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { motion, useInView } from "framer-motion";

const steps = [
  { number: "01", titleKey: "arrival.step1Title", descKey: "arrival.step1Desc", delay: 0 },
  { number: "02", titleKey: "arrival.step2Title", descKey: "arrival.step2Desc", delay: 0.1 },
  { number: "03", titleKey: "arrival.step3Title", descKey: "arrival.step3Desc", delay: 0.2 },
];

const ArrivalSteps = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  return (
    <section className="bg-lux-bg pt-8 pb-8 md:pt-16 md:pb-10 px-6">
      <div className="max-w-5xl mx-auto">

        <div className="text-center mb-8 md:mb-14">
          <p className="text-lux-accent text-xs font-bold tracking-widest uppercase mb-3">
            {t("arrival.subtitle")}
          </p>
          <h2 className="text-3xl font-medium tracking-wide text-lux-cream">
            {t("arrival.title")}
          </h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map(({ number, titleKey, descKey, delay }) => (
            <motion.div
              key={number}
              className="flex flex-col items-center text-center flex-1 bg-lux-surface border border-lux-muted p-8 transition-colors duration-300 hover:border-lux-accent"
              initial={{ opacity: 0, y: 32 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 32 }}
              transition={{ duration: 0.5, delay: delay * 1.8, ease: [0.22, 1, 0.36, 1] }}
            >
              <span className="flex items-center justify-center w-12 h-12 mb-5 border border-lux-accent text-lux-accent text-lg font-bold">
                {number}
              </span>
              <h3 className="cormorant text-lux-cream font-medium text-xl mb-2">
                {t(titleKey)}
              </h3>
              <p className="text-lux-cream/60 text-sm leading-relaxed max-w-[220px]">
                {t(descKey)}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 md:mt-14 flex flex-col items-center gap-5 text-center">
          <p className="text-lux-cream/55 text-sm max-w-sm leading-relaxed">
            {t("arrival.reassurance")}
          </p>
          <button
            type="button"
            className="inline-flex items-center gap-2 bg-lux-accent-strong hover:bg-lux-highlight text-[#161310] font-semibold py-3 px-7 rounded-sm transition-colors text-sm"
          >
            <FaWhatsapp className="w-5 h-5" />
            {t("arrival.whatsappBtn")}
          </button>
        </div>

      </div>
    </section>
  );
};

export default ArrivalSteps;
